import { useLazyQuery } from "@apollo/client";

import {
  CheckGiftingCodeAvailabilityQuery,
  CheckGiftingCodeAvailabilityQueryVariables,
} from "@ctypes";
import { CHECK_GIFTING_CODE_AVAILABILITY } from "@graphql";

export const useCheckGiftingCodeAvailability = () => {
  return useLazyQuery<
    CheckGiftingCodeAvailabilityQuery,
    CheckGiftingCodeAvailabilityQueryVariables
  >(CHECK_GIFTING_CODE_AVAILABILITY);
};
